
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/appdownload",
      function () {
        return require("private-next-pages/appdownload/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/appdownload"])
      });
    }
  